import React from 'react';

import { Table } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import Container from 'components/shared/Container';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import { REBATE_ANALYSIS_UPLOAD_CONTENT, getURL } from 'lib/networking/endpoints';
import useGet from 'lib/hooks/useGet';

function RebateAnalysisFileView() {
  const { upload_id } = useParams();

  const { data, loading, error } = useGet(getURL(REBATE_ANALYSIS_UPLOAD_CONTENT, { upload_id }));

  const { headers = [], rows = [], total_rows } = data?.data || {};
  const totalRows = total_rows ?? rows.length;

  if (loading) {
    return (
      <Container>
        <LoadingSpinner short />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <p className="text-danger ml-3">Failed to load file preview. Please try again.</p>
      </Container>
    );
  }

  return (
    <Container>
      <h3 className="font-weight-bold ml-3 mb-4">File Preview</h3>
      {totalRows > rows.length && (
        <p className="text-muted ml-3 small">
          Showing first {rows.length.toLocaleString()} of {totalRows.toLocaleString()} rows.
        </p>
      )}
      {rows.length === 0 ? (
        <p className="text-muted ml-3">No data found in file.</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <Table bordered striped hover size="sm">
            <thead>
              <tr>
                {headers.map((header, i) => (
                  <th key={i}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Container>
  );
}

export default RebateAnalysisFileView;
